import { __assign, __awaiter, __extends, __generator, __spreadArray } from "tslib";
import { DocumentData, DOCUMENT_DATA_TYPE, OfflineData, } from '@tencent/ark-model';
import { DocumentDataStorage, OfflineDataStorage, SortOrder, } from '@tencent/ark-storage';
import { AbstractPadInfoCreator, } from '../../pad-info/pad-info-creator';
import { CommonChangeDataComposer } from '../../util/change-data-composer';
import { ApiError } from '../../error/api-error';
import { ApiErrorCode } from '../../error/api-error-code';
import { LoggerProxy } from '../../logger/logger-proxy';
var BasePadInfoCreator = /** @class */ (function (_super) {
    __extends(BasePadInfoCreator, _super);
    function BasePadInfoCreator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 通用的生成创建文档的关键帧数据的方法，目前有 doc 和 sheet 走本通用逻辑
     * @param option 请求信息
     * @param config offline api 的配置信息
     * @param storageManager 数据库存储操作对象
     * @returns 生成文档需要的关键帧数据
     */
    Object.defineProperty(BasePadInfoCreator.prototype, "buildCreateRequestKeyframe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (option, config, storageManager) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var offlineDataCollection, offlineDataStorage, documentDataCollection, documentDataStorage, initDocumentData, offlineData, lastModifyTimestamp, waitToComposeChangeData, composedChangeData, atextAndApool;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            LoggerProxy.info(BasePadInfoCreator.tag, '开始生成创建文档请求数据, option = ', option, ', config = ', config);
                            offlineDataCollection = storageManager.storage.collection(OfflineData);
                            offlineDataStorage = new OfflineDataStorage(offlineDataCollection);
                            documentDataCollection = storageManager.storage.collection(DocumentData);
                            documentDataStorage = new DocumentDataStorage(documentDataCollection);
                            return [4 /*yield*/, this.getInitDocumentData(option, config, documentDataStorage)];
                        case 1:
                            initDocumentData = _b.sent();
                            return [4 /*yield*/, this.getOfflineData(option, config, offlineDataStorage)];
                        case 2:
                            offlineData = _b.sent();
                            lastModifyTimestamp = offlineData.length > 0
                                ? Math.max.apply(Math, offlineData.map(function (item) { var _a; return (_a = item.lastModifyTimestamp) !== null && _a !== void 0 ? _a : 0; })) : (_a = initDocumentData.lastModifyTimestamp) !== null && _a !== void 0 ? _a : 0;
                            waitToComposeChangeData = option.withOfflineData ? __spreadArray([initDocumentData], offlineData, true) : [initDocumentData];
                            composedChangeData = this.composeChangeData(waitToComposeChangeData);
                            atextAndApool = this.getAtextAndApool(initDocumentData);
                            return [2 /*return*/, __assign(__assign({}, atextAndApool), { lastModifyTimestamp: lastModifyTimestamp, data: composedChangeData })];
                    }
                });
            });
        }
    });
    ;
    /**
     * 通用的获取文档关键帧 DocumentData 数据的方式
     * PS：目前 doc 和 slide 都走这个通用逻辑，sheet 的适配器中会重写实现
     * @param option 请求参数
     * @param config offline api配置信息
     * @param changeStorage change data storage
     * @returns 文档关键帧 DocumentData
     */
    Object.defineProperty(BasePadInfoCreator.prototype, "getInitDocumentData", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (option, config, changeStorage) {
            return __awaiter(this, void 0, void 0, function () {
                var initDocumentData;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            LoggerProxy.info(BasePadInfoCreator.tag, '获取文档关键帧数据, option = ', option, ', config = ', config);
                            return [4 /*yield*/, changeStorage.getChanges({
                                    uid: config.user.uid,
                                    secretId: option.secretId,
                                    types: [DOCUMENT_DATA_TYPE.init],
                                }, {
                                    orderPath: 'dataVersion',
                                    sortOrder: SortOrder.DESCENDING,
                                    limit: 1,
                                })];
                        case 1:
                            initDocumentData = (_a.sent())[0];
                            if (!initDocumentData) {
                                LoggerProxy.error(BasePadInfoCreator.tag, '获取文档关键帧数据异常，本地数据库不存在数据');
                                throw new ApiError({
                                    code: ApiErrorCode.CreateDocumentError,
                                    message: "".concat(BasePadInfoCreator.tag, " \u83B7\u53D6\u6587\u6863\u5173\u952E\u5E27\u6570\u636E\u5F02\u5E38\uFF0C\u672C\u5730\u6570\u636E\u5E93\u4E0D\u5B58\u5728\u6570\u636E. id: ").concat(config.user.uid, ", secretId: ").concat(option.secretId, "."),
                                });
                            }
                            return [2 /*return*/, initDocumentData];
                    }
                });
            });
        }
    });
    /**
     * 转换 changeData 为 CGI 提交数据的格式
     * PS: 目前 doc 和 sheet 是通用的方式，slide 是额外的实现
     * @param changeData 关键帧数据 + 离线数据
     */
    Object.defineProperty(BasePadInfoCreator.prototype, "composeChangeData", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (changeData) {
            LoggerProxy.info(BasePadInfoCreator.tag, '开始转换文档数据为创建文档请求 CGI 数据');
            var composedChangeData = CommonChangeDataComposer.compose(changeData);
            try {
                return JSON.stringify(composedChangeData);
            }
            catch (error) {
                LoggerProxy.error(BasePadInfoCreator.tag, '转换文档数据为创建文档请求 CGI 数据时发生异常, error = ', error);
                throw new ApiError({
                    code: ApiErrorCode.CreateDocumentError,
                    message: "".concat(BasePadInfoCreator.tag, " \u8F6C\u6362\u6587\u6863\u6570\u636E\u4E3A\u521B\u5EFA\u6587\u6863\u8BF7\u6C42 CGI \u6570\u636E\u65F6\u53D1\u751F\u5F02\u5E38. \u9519\u8BEF\u4FE1\u606F: ").concat(error.message, "."),
                });
            }
        }
    });
    /**
     * 读取离线数据，目前默认的实现为返回空数据
     * PS: 目前带数据创建的能力只有 doc 支持，故 doc 的适配器会进行对应的实现
     * @returns 离线数据
     */
    Object.defineProperty(BasePadInfoCreator.prototype, "getOfflineData", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (option, config, changeStorage) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, []];
                });
            });
        }
    });
    /**
     * 生成 atext 和 apool 数据
     * PS：目前只有 doc 创建时需要生成该数据，由 doc 的适配器进行实现
     * @returns atext 和 apool 数据
     */
    Object.defineProperty(BasePadInfoCreator.prototype, "getAtextAndApool", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (documentData) {
            return {};
        }
    });
    Object.defineProperty(BasePadInfoCreator, "tag", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'BasePadInfoCreator'
    });
    return BasePadInfoCreator;
}(AbstractPadInfoCreator));
export { BasePadInfoCreator };
